var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTopLine2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 40,
    viewBox: "0 0 78 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.1251 8.21028C68.3699 10.8798 71.5432 12.0348 74.2127 10.79C76.8823 9.54513 78.0372 6.3719 76.7924 3.70235C75.5476 1.0328 72.3743 -0.122156 69.7048 1.12267C67.0352 2.3675 65.8803 5.54073 67.1251 8.21028ZM1.42262 39.9512L72.3814 6.86262L71.5361 5.05001L0.577382 38.1386L1.42262 39.9512Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopLine2);
export default __webpack_public_path__ + "static/media/topLine2.01306e67f6756af55c8d0a43804b207a.svg";
export { ForwardRef as ReactComponent };